import { useTaskContext } from "@/contexts/useTaskContext";
import { AppDeploymentStatus } from "@/gql/__generated__/graphql";

export const GetDeployingStatus = (appID: string) => {
  const { taskStatus, newAppID, isAppDisabled } = useTaskContext();
  const isNewApp = newAppID === appID;
  const isNewAppDisabled = isAppDisabled && isNewApp;
  const isDeployingNewApp =
    taskStatus === AppDeploymentStatus.Pending && isNewApp;
  const isDoneDeployingNewApp =
    taskStatus === AppDeploymentStatus.Running && isNewApp;
  const isErrorDeployingNewApp =
    (taskStatus === AppDeploymentStatus.Error ||
      taskStatus === AppDeploymentStatus.Stopped) &&
    isNewApp;
  return {
    isNewApp,
    isNewAppDisabled,
    isDeployingNewApp,
    isDoneDeployingNewApp,
    isErrorDeployingNewApp
  };
};
